export const HERO_MODEL = {
  errorStep: "/consulta-soat/error",
  nextStep: "/consulta-soat/resultado-no-cliente",
  nextStepHP: "/consulta-soat/resultado-cliente",
  title: "Consulta tu SOAT Virtual",
  subtitle: "Recuerda que aquí podrás consultar y descargar tu SOAT Virtual",
  onestep: true
};

export const GOALS_MODEL = {
  title: "Nuestros números nos respaldan",
  goals: [
    {
      icon: "RideFiConfettiLight",
      amount: "3,456",
      goal: "SOAT emitidos"
    },
    {
      icon: "RideFiPendingSoatLight",
      amount: "2,988",
      goal: "SOAT emitidos"
    },
    {
      icon: "RideFiNotificationsLight",
      amount: "24 hrs",
      goal: "Disponibles para ti"
    }
  ]
};

export const COVERAGE_MODEL = {
  altImg: "Imagen coverage",
  coverageTitle: "Consulta tu SOAT y descubre los beneficios que RIMAC te ofrece",
  coverages: [
    {
        title: "Descuentos en gasolina REPSOL",
        alt: "Gasolina",
        code: "secundario",
        icon: "RideIcGasolineLight",
        titleModal: "Descuento en gasolina REPSOL",
        subtitleModal: "¿De qué se trata el descuento? Descuento Soles/Galón sobre precio pizarra (incluye IGV)",
        listModal: [
          {
              id: 0,
              text: "Producto EFITEC 98 - SOAT S/0.90"
          },
          {
              id: 1,
              text: "Producto EFITEC 90 - SOAT S/0.50"
          },
          {
              id: 2,
              text: "Producto Diésel e+ - SOAT S/0.30"
          },
          {
              id: 3,
              text: "Producto GLP - SOAT 3%"
          }
        ]
    },
    {
        title: "25% OFF Baterías ETNA",
        alt: "Baterias",
        code: "secundario",
        icon: "RideIcBatteryLight",
        titleModal: "25% OFF Baterías ETNA",
        subtitleModal: "¿Cómo puedo acceder al descuento? Para acceder al descuento menciona el código RIMACETNA y presenta la póliza física o digital",
        listModal: [
          {
              id: 0,
              text: "Válido para clientes de SOAT Rimac Digital con póliza vigente"
          },
          {
              id: 1,
              text: "En las ciudades de Lima metropolitana, Callao, Trujillo y Arequipa"
          },
          {
              id: 2,
              text: "El descuento no es acumulable con otras promociones"
          }
        ]
    },
    {
        title: "Hasta 20% de descuento en grúas y asistencia vial",
        alt: "Gruas",
        code: "secundario",
        icon: "RideIcTowTruckLight",
        titleModal: "Hasta 20% de descuento en grúas y asistencias vial",
        subtitleModal: "¿Cómo acceder?",
        paragraphModal: "Los clientes pueden comunicar al número directo: 613-6373",
        subtitleTitleModal: "Condiciones",
        listModal: [
          {
              id: 0,
              text: "Los clientes de SOAT RIMAC tendrán hasta 20% de descuento en Asistencias viales y Envíos de Grúas a nivel nacional."
          }
        ]
    }
  ]
};

export const BANNER_MODEL = {
  text: "Tu seguridad es primero ¡Compra tu SOAT Virtual y viaja tranquilo!"
};

export const QUESTION_MODEL = {
  title: "Respondemos a las consultas sobre tu SOAT Virtual",
  questions: [
    {
      icon: "RideGlSoatSolid",
      question: "¿Cuáles son los requisitos para comprar un SOAT?",
      answer: "Para adquirir un SOAT en RIMAC Seguros, deberás proporcionar tu número de DNI, la placa del vehículo y la información sobre su uso. Es importante tener en cuenta que el SOAT es un requisito obligatorio y la falta del mismo puede generar multas. Para evitar cualquier tipo de inconveniente, te recomendamos realizar consultas periódicas en nuestra página web para conocer el estado actual de tu SOAT."
    },
    {
      icon: "RideGlInformationSolid",
      question: "¿Cómo saber cuándo vence mi SOAT?",
      answer: "Para saber cuándo vence tu SOAT, puedes consultar la fecha de vencimiento en el comprobante de pago correspondiente o bien verificar la información a través de nuestro módulo de consulta. El módulo para realizar la consulta de tu SOAT se encuentra disponible en la página de inicio y te permitirá ingresar el número de placa del vehículo y tu número de DNI para obtener la información de tu SOAT."
    },
    {
      icon: "RideGlDocumentSolid",
      question: "¿Cómo descargar mi SOAT?",
      answer: "Para descargar tu SOAT, debes ingresar a la sección “Consulta tu SOAT y proporcionar tu número de placa vehicular y DNI. Una vez dentro, selecciona la opción ¨Descarga tu SOAT¨ y se genera un documento en formato PDF que podrás guardar en tu dispositivo."
    },
    {
      icon: "RideGlStarSolid",
      question: "¿Qué hacer si perdí mi SOAT?",
      answer: "En caso de haber extraviado tu SOAT, es fundamental que solicites un duplicado de manera inmediata. Puedes realizar la consulta de tu SOAT en la página de RIMAC Seguros para obtener la información de contacto o comunicarte directamente con la compañía para solicitar el duplicado. Recuerda que conducir sin SOAT puede acarrear sanciones y multas."
    },
    {
      icon: "RideGlFileSolid",
      question: "¿Qué diferencias hay entre el SOAT y el CAT?",
      answer: "El SOAT cubre los daños a terceros y gastos médicos en caso de accidentes, mientras que el CAT es un seguro complementario que cubre los gastos médicos de los ocupantes de vehículo asegurado. Para obtener más información sobre estos detalles, puedes consultar tu SOAT en la página web de RIMAC Seguros."
    }
  ]
};

export const FOOTER_MODEL = {
  altFooter: "Logo Footer",
  address: "Calle Las Begonias 650 Piso 10, San Isidro.",
  txtFooter: "© [year] RIMAC Seguros y Reaseguros."
}
